(()=>{if(window.__ValuraaAppShellV2)return;window.__ValuraaAppShellV2=true;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const mobile=matchMedia('(max-width:899px)');
let lastY=scrollY,direction=0,travel=0,ticking=false,pressed=null;
const clearPressed=()=>{pressed?.classList.remove('vl-app-pressed');pressed=null};
const sync=()=>{
  const y=Math.max(0,scrollY),delta=y-lastY;
  if(document.body.classList.contains('vf-drawer-open')||document.documentElement.classList.contains('vfh2-locked')||document.documentElement.classList.contains('vfh2-search-locked')||document.body.classList.contains('vl-keyboard-open')){
    document.body.classList.remove('vl-app-scroll-down');direction=0;travel=0;
  }else if(y<110){
    document.body.classList.remove('vl-app-scroll-down');direction=0;travel=0;
  }else if(Math.abs(delta)>1){
    const next=delta>0?1:-1;
    if(next!==direction){direction=next;travel=0}
    travel+=Math.abs(delta);
    if(travel>=28){
      document.body.classList.toggle('vl-app-scroll-down',direction>0&&y>140);
      travel=0;
    }
  }
  lastY=y;ticking=false;
};
const onScroll=()=>{if(!ticking){ticking=true;requestAnimationFrame(sync)}};
let scrollBound=false;
const syncScrollBinding=()=>{
  if(mobile.matches&&!scrollBound){
    addEventListener('scroll',onScroll,{passive:true});
    scrollBound=true;
    lastY=scrollY;
  }else if(!mobile.matches&&scrollBound){
    removeEventListener('scroll',onScroll);
    scrollBound=false;
    ticking=false;
    direction=0;
    travel=0;
    document.body.classList.remove('vl-app-scroll-down');
  }
};
syncScrollBinding();
mobile.addEventListener?.('change',syncScrollBinding);
document.addEventListener('pointerdown',e=>{
  const el=e.target.closest('.vfdock__item,.vfh2__menu-button,.vfh2__search-trigger,.vfh2__bag,.vhx__cta,.vf-btn,.vfp-sticky__add,.vfp-sticky__buy,.vhome-card__add,.vugc-product__action,.vfc-quick button,.vf-drawer__checkout,.vf-cart-rec__action');
  if(!el||reduced)return;
  clearPressed();pressed=el;el.classList.add('vl-app-pressed');
  if(e.pointerType!=='mouse')navigator.vibrate?.(3);
},{passive:true});
addEventListener('pointerup',clearPressed,{passive:true});
addEventListener('pointercancel',clearPressed,{passive:true});
addEventListener('blur',clearPressed);
document.addEventListener('visibilitychange',()=>{if(document.hidden){document.body.classList.remove('vl-app-scroll-down');clearPressed()}});
})();
;(()=>{if(window.__ValuraaAppShellV3)return;window.__ValuraaAppShellV3=true;
const mq=matchMedia('(max-width:899px)');
const editable='input,textarea,select,[contenteditable="true"]';
const syncKeyboard=()=>{
  if(!mq.matches){
    document.body.classList.remove('vl-keyboard-open');
    return;
  }
  const vv=window.visualViewport;
  const viewportReduced=vv?window.innerHeight-vv.height>140:false;
  const focused=!!document.activeElement?.matches?.(editable);
  document.body.classList.toggle('vl-keyboard-open',viewportReduced&&focused);
};
const syncDock=()=>{
  const dock=document.querySelector('[data-vfdock]');
  if(!dock)return;
  const path=location.pathname;
  dock.querySelectorAll('[aria-current="page"]').forEach(el=>el.removeAttribute('aria-current'));
  let active=null;
  if(path==='/')active=dock.querySelector('[data-vfdock-home]');
  else if(path.startsWith('/collections')||path.startsWith('/products/'))active=dock.querySelector('[data-vfdock-collections]');
  else if(path.startsWith('/cart'))active=dock.querySelector('[data-vfdock-cart]');
  else if(path.startsWith('/search'))active=dock.querySelector('[data-vfdock-search]');
  active?.setAttribute('aria-current','page');
};
visualViewport?.addEventListener('resize',syncKeyboard,{passive:true});
visualViewport?.addEventListener('scroll',syncKeyboard,{passive:true});
document.addEventListener('focusin',syncKeyboard);
document.addEventListener('focusout',()=>setTimeout(syncKeyboard,0));
addEventListener('orientationchange',()=>setTimeout(syncKeyboard,120),{passive:true});
addEventListener('pageshow',()=>{syncKeyboard();syncDock()});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{syncKeyboard();syncDock()},{once:true});
else{syncKeyboard();syncDock()}
})();